import styled, { css } from 'styled-components';
export const TransparentBox = styled.div `
  position: absolute;
  ${({ position }) => position === 'top'
    ? css `
          bottom: calc(100% - 1.8rem);
        `
    : css `
          top: calc(100% - 1.8rem);
        `};
  left: -9.7rem;

  display: none;

  background-color: transparent;

  ${({ position }) => position === 'top' ? 'padding-bottom: 3.8rem' : 'padding-top: 3.8rem'};
`;
export const TooltipWrapper = styled.div `
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};

  box-shadow: ${({ theme }) => theme.shadows.sm};
  background-color: ${({ theme }) => theme.colors.surface.default};

  z-index: ${({ theme }) => theme.zIndex.low};

  &:after {
    content: '';

    position: absolute;

    left: calc(50% - 1.05rem);

    width: 2.1rem;
    height: 2.1rem;

    z-index: -1;

    background-color: ${({ theme }) => theme.colors.surface.default};
    border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};

    ${({ position }) => position === 'top'
    ? css `
            top: calc(100% - 1.05rem);
            transform: rotate(45deg);

            border-bottom-right-radius: 0.2rem;
            border-top: none;
            border-left: none;
          `
    : css `
            top: -1.15rem;

            transform: rotate(45deg);

            border-top-left-radius: 0.2rem;
            border-bottom: none;
            border-right: none;
          `}
  }
`;
export const TooltipContainer = styled.div `
  position: relative;

  cursor: pointer;

  &:hover {
    ${TransparentBox} {
      display: initial;
    }
  }
`;
export const Header = styled.div `
  position: relative;

  width: 100%;

  padding: 1.1rem 1.6rem 0.7rem;

  z-index: 1;
`;
//# sourceMappingURL=styles.js.map